import React from 'react'
import cx from 'classnames'
export default ({
  headline,
  content,
  isExpanded,
  ctaCopy,
  hideCta,
  primaryColor,
  secondaryColor
}) => {
  return <div className="slider-message-callout">
    {(!isExpanded || hideCta) && <span className="callout-tail" />}
    <div className="Content">
      <div className={cx('Headline', isExpanded)}>{headline}</div>
      {isExpanded && [
        <div className="ScrollableContent">
          <div>{content}</div>
        </div>,
        !hideCta && <button
          className="CtaButton"
          style={{
            backgroundColor: primaryColor,
            borderColor: primaryColor,
            color: secondaryColor,
            lineHeight: '18px',
            height: 'initial',
            padding: '8px' }}
          >{ctaCopy}</button>
      ]
      }
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./src/scripts/components/shared/MessagePreviews/SliderMessage/SliderMessageBuilder/SliderMessagePreview.js